import React, { Component } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row } from 'reactstrap';

class DTCDeclined extends Component {
  render() {
    return (
      <div className="page-preapproved narrow">
        <Container>
          <Row>
            <Col lg={{size:8, offset: 2}} className="text-center mb-2 mt-2 mt-md-4">
              <img src="/icons/declined.svg" alt="Declined" className="mb-3" />
              <h2 className="mb-2">Unfortunately, we were unable to approve your application at this time</h2>
              <p className="mb-4">You will receive an adverse action notice within 30 days that will provide you with the specific reason(s) as to why we were unable to approve your application.</p>
              <Row>
                <Col sm={{size: 8, offset: 2}} md={{size: 6, offset: 3}}>
                  <h4 className="mb-4 text-primary">Please contact your merchant for other financing options:</h4>
                  <Card className="dark-shadow">
                    <CardBody>
                      <h4>Petland (Kennesaw)</h4>
                      <p className="mb-0">1234 Merchant St.<br />
                      Kennessaw, GA 12345<br />
                      (555) 456-7890</p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default DTCDeclined;
